export const ADDRESSBOOK_PANEL_BAR_HEIGHT = 36;

export const addressBookPanelHeaderSx = {
  py: 0,
  height: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  minHeight: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  maxHeight: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  boxSizing: "border-box",
  flexShrink: 0,
  overflow: "hidden",
};

export const addressBookPanelFooterSx = {
  py: 0,
  height: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  minHeight: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  maxHeight: ADDRESSBOOK_PANEL_BAR_HEIGHT,
  boxSizing: "border-box",
  flexShrink: 0,
  overflow: "hidden",
};
